import React, { useState, useEffect } from "react";
import CancelButton from "../../../components/CancelButton";
import SaveButton from "../../../components/SaveButton";
import { useQueryClient } from "react-query";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import { addEntity } from "../../../actions/Utilities/Entity";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import { toast } from "../../../components/toastNotification";
const AddEntityForm = ({ setaddEntity, setSearchEntities, refetch }) => {
  const queryClient = useQueryClient();
  const [statesOptions, setStatesOptions] = useState([]);
  const [state, setState] = useState([]);
  const [licensetype, setlicensetype] = useState([]);
  const [hasEntity, setHasEntity] = useState(false);

  const EntityAddRow = {
    EntityName: "",
    EntityEIN: "",
    LicenseNumber: "",
    StateID: 0,
    LicenseTypeID: 0,
    DRLP1: "",
    DRLP1LicenseType: "",
    DRLP1ExpDate: "",
    DRLP1LicenseNumber: "",
    DisregardedForTax: "",
    Comments: "",
    ExpirationDate: "",
    Notes: "",
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    IsActive: true,
    StateCode: "",
    usedInMexico: false,
  };
  const [addEntityData] = useState([EntityAddRow]);
  const [licenseTypeOptions, setlicenseTypeOptions] = useState([]);
  const [, setEntityExist] = useState(false);
  const [changed, setChanged] = useState(false);
  const [openModal, setopenModal] = useState(false);

  useEffect(() => {
    if (statesOptions.length === 0) {
      setStatesOptions(
        queryClient.getQueryData(["States"]).map((data) => {
          return {
            label: data.state,
            value: data.stateId,
          };
        })
      );
    }

    if (licenseTypeOptions.length === 0) {
      setlicenseTypeOptions(
        queryClient.getQueryData(["LicenseTypes"]).map((data) => {
          return { label: data.licenseTypeName, value: data.licenseTypeId };
        })
      );
    }
  }, [statesOptions, licenseTypeOptions]);

  //Function cfor Contact Table Select Input
  const handleAddEntity = (
    processname,
    fieldName,
    selectedValue,
    selectedLabel
  ) => {
    setEntityExist(false);
    setChanged(true);
    if (processname === "AddEntity") {
      var rowIndex = 0;

      if (fieldName === "EntityName") {
        addEntityData[rowIndex].EntityName = selectedValue?.trim();
      }

      if (fieldName === "EntityEIN") {
        addEntityData[rowIndex].EntityEIN = selectedValue?.trim();
      }

      if (fieldName === "LicenseNumber") {
        addEntityData[rowIndex].LicenseNumber = selectedValue?.trim();
      }

      if (fieldName === "StateId") {
        addEntityData[rowIndex].StateID = selectedValue;
        addEntityData[rowIndex].StateCode = selectedLabel;
      }

      if (fieldName === "LicenseTypeID") {
        addEntityData[rowIndex].LicenseTypeID = selectedValue;
      }

      if (fieldName === "DRLP1") {
        addEntityData[rowIndex].DRLP1 = selectedValue?.trim();
      }

      if (fieldName === "DRLP1LicenseType") {
        addEntityData[rowIndex].DRLP1LicenseType = selectedValue.toString();
      }
      if (fieldName === "DRLP1ExpDate") {
        addEntityData[rowIndex].DRLP1ExpDate = selectedValue;
      }

      if (fieldName === "DRLP1LicenseNumber") {
        addEntityData[rowIndex].DRLP1LicenseNumber = selectedValue?.trim();
      }
      if (fieldName === "DisregardedForTax") {
        addEntityData[rowIndex].DisregardedForTax = selectedValue?.trim();
      }
      if (fieldName === "Comments") {
        addEntityData[rowIndex].Comments = selectedValue?.trim();
      }

      if (fieldName === "ExpirationDate") {
        addEntityData[rowIndex].ExpirationDate = selectedValue;
      }

      if (fieldName === "Notes") {
        addEntityData[rowIndex].Notes = selectedValue?.trim();
      }
      addEntityData[0].EntityName !== "" && addEntityData[0].StateID !== 0
        ? setHasEntity(true)
        : setHasEntity(false);
      addEntityData[0].IsActive = true;
    }
  };

  //Update entity function
  const handleClickSave = () => {
    if (changed) {
      if (
        addEntityData[0].EntityName !== "" &&
        addEntityData[0].StateID !== 0
      ) {
        addEntity(addEntityData[0])
          .then((res) => {
            if (res.data === "duplicate") {
              toast.fire(
                "Adding new Entity failed",
                "Entity already exist",
                "error"
              );
              setopenModal(false);
            } else if (res.status === 201) {
              queryClient.invalidateQueries("Entity");
              toast.fire("Success", "Entity Added Successfully", "success");
              refetch();
              setaddEntity(false);
              setopenModal(false);
            } else {
              toast.fire(
                "Adding new Entity failed",
                "Server Error: Cannot add new Entity",
                "error"
              );
            }
          })
          .catch((err) => {
            toast.fire("Failed", "Failed to Add Entity", "error");
            setopenModal(false);
          });
      } else {
        toast.fire("Saving Failed", "No Changes have been made", "error");
        setopenModal(false);
      }
    } else {
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "warning"
      );
      setopenModal(false);
    }
  };

  return (
    <div className="w-full">
      <div className="p-3 py-2 space-y-1 border-l-2  border-primary box-shadow pt-2 ">
        <div className="flex items-center gap-x-2 pb-1">
          <div className="text-base text-primary font-bold">Add New Entity</div>
          <SaveButton
            className={`flex items-center shadow-md text-xs font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
                        ${!hasEntity ? "opacity-50" : "opactiy-100"}`}
            disabled={!hasEntity}
            onClick={() => {
              setopenModal(true);
            }}
            buttonText={"Save"}
          />
          <CancelButton
            onClick={() => {
              setaddEntity(false);
              setSearchEntities("");
              refetch();
            }}
          />
        </div>
        <div className="mt-2 h-0.5 w-full border-b-2 border-secondary "></div>
        <div className="italic text-secondary text-xs3 pt-1">
          <b> Note: </b> All fields with * are required to fill
        </div>

        {/* second row */}
        <div className="w-full -mx-2">
          {/* firstrow */}
          <div className="text-xs font-medium ">
            <div className="grid  grid-cols-3  gap-5 m-2 ">
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  <span className="text-red-500">*</span> Entity Name:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.entityName}
                    onChange={(e) =>
                      handleAddEntity("AddEntity", "EntityName", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  <span className="text-red-500">*</span> State:
                </label>
                <div className="col-span-2">
                  <SelectInput
                    options={statesOptions}
                    defaultValue={state}
                    onChange={(selectedOptions) => {
                      setState(selectedOptions);
                      handleAddEntity(
                        "AddEntity",
                        "StateId",
                        selectedOptions == null ? "" : selectedOptions.value,
                        selectedOptions == null ? "" : selectedOptions.label
                      );
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  Entity EIN:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.entityEin}
                    onChange={(e) =>
                      handleAddEntity("AddEntity", "EntityEIN", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="grid  grid-cols-3  gap-5 m-2 ">
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  License Number:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.licenseNumber}
                    onChange={(e) =>
                      handleAddEntity(
                        "AddEntity",
                        "LicenseNumber",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  License Type:
                </label>
                <div className="col-span-2">
                  <SelectInput
                    options={licenseTypeOptions}
                    defaultValue={licensetype}
                    onChange={(selectedOptions) => {
                      setState(selectedOptions);
                      handleAddEntity(
                        "AddEntity",
                        "LicenseTypeID",
                        selectedOptions == null ? 0 : selectedOptions.value
                      );
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  Expiration Date:
                </label>
                <div className="col-span-2">
                  <TextInput
                    placeholder="Expiration Date"
                    value={addEntityData.ExpirationDate}
                    type="date"
                    onChange={(e) => {
                      handleAddEntity(
                        "AddEntity",
                        "ExpirationDate",
                        e.target.value
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            {/* secondrow */}
            {/* this       */}
            <div className="grid  grid-cols-3  gap-5  m-2">
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  DRLP1:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.drlp1}
                    onChange={(e) =>
                      handleAddEntity("AddEntity", "DRLP1", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  DRLP1 License Type:
                </label>
                <div className="col-span-2">
                  <SelectInput
                    options={licenseTypeOptions}
                    defaultValue={licensetype}
                    onChange={(selectedOptions) => {
                      setlicensetype(selectedOptions);
                      handleAddEntity(
                        "AddEntity",
                        "DRLP1LicenseType",
                        selectedOptions == null ? "" : selectedOptions.label
                      );
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  DRLP1 Expiration Date:
                </label>
                <div className="col-span-2">
                  <TextInput
                    placeholder="DRLP1Exp Date"
                    value={addEntityData.DRLP1ExpDate}
                    type="date"
                    onChange={(e) => {
                      handleAddEntity(
                        "AddEntity",
                        "DRLP1ExpDate",
                        e.target.value
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="grid  grid-cols-3  gap-5  m-2">
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  DRLP1 License Number:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.drlp1licenseNumber}
                    onChange={(e) =>
                      handleAddEntity(
                        "AddEntity",
                        "DRLP1LicenseNumber",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  Comments:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.comments}
                    onChange={(e) =>
                      handleAddEntity("AddEntity", "Comments", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  Disregarded For Tax:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.disregardedForTax}
                    onChange={(e) =>
                      handleAddEntity(
                        "AddEntity",
                        "DisregardedForTax",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>
            {/* secondrow */}
            <div className="grid  grid-cols-3  gap-5 m-2">
              <div className="grid grid-cols-1 md:grid-cols-3 w-full items-center gap-1 ">
                <label className="block font-medium text-gray-700 my-1 text-left mr-2">
                  Notes:
                </label>
                <div className="col-span-2">
                  <TextInput
                    defaultValue={addEntityData.notes}
                    onChange={(e) =>
                      handleAddEntity("AddEntity", "Notes", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {/* secondrow */}
        </div>
        {/* second row */}
      </div>
      <ConfirmBoxModal
        ModalTitle="Add New Entity"
        qConfirmation=" Are you sure you want to add this?"
        isOpen={openModal}
        onClose={() => setopenModal(false)}
        onClickFunction={() => {
          handleClickSave();
        }}
      />

      <div className="hidden sm:block" aria-hidden="true">
        <div className="col-span-2"></div>
      </div>
    </div>
  );
};

export default AddEntityForm;
